let lkQuizzStartChapt1 = [
    {
        question: 'Pergunta provisória 1',
        correct_answer: 'Resposta 1',
        incorrect_answers:
            [
                'Resposta 2',
                'Resposta 3',
                'Resposta 4'
            ]
    },
    {
        question: 'Pergunta provisória 2',
        correct_answer: 'Resposta 1',
        incorrect_answers:
            [
                'Resposta 2',
                'Resposta 3',
                'Resposta 4'
            ]
    },
    {
        question: 'Pergunta provisória 3',
        correct_answer: 'Resposta 1',
        incorrect_answers:
            [
                'Resposta 2',
                'Resposta 3',
                'Resposta 4'
            ]
    },
    {
        question: 'Pergunta provisória 4',
        correct_answer: 'Resposta 1',
        incorrect_answers:
            [
                'Resposta 2',
                'Resposta 3',
                'Resposta 4'
            ]
    },
    {
        question: 'Pergunta provisória 5',
        correct_answer: 'Resposta 1',
        incorrect_answers:
            [
                'Resposta 2',
                'Resposta 3',
                'Resposta 4'
            ]
    }
]

export {
    lkQuizzStartChapt1
}